import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { withApollo } from 'react-apollo';
import { signout } from '../redux/actions/userActions';
import { withRouter } from 'react-router-dom';
import HelpText from './content_management/HelpText.js';

class HelpTextModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { someKey: 'someValue' };
  }

  componentDidMount() {
    this.setState({ someKey: 'otherValue' });
  }

  render() {
    let helptext = HelpText.data
    helptext = helptext.replace('{framework}',this.props.framework.toUpperCase())
    helptext = helptext.replace('{category}',this.props.referenceID)
    helptext = helptext.replace('{advice}',this.props.advice)
    // let body = document.createElement('div')
    // body.innerHTML = this.props.body ? this.props.body.replace(/\\+n/g,'') : helptext.replace(/\\+n/g,'')
    return (
      <Modal 
        isOpen={this.props.modal}
        toggle={this.props.toggle}
        className="help-text-modal"
      >
        <ModalHeader>
          {this.props.title} - Reference Text
          {(this.props.user &&
            this.props.user['cognito:groups'] &&
            this.props.user['cognito:groups'].find(e => { return e === 'ContentEditor' })) ?
            <div className="modal__edit">
            <span className='lnr lnr-pencil'
            onClick={() => {
              this.props.history.push(`/app/editor/${this.props.editUrl}`)
            }}>
            </span>
          </div>:
          null}
          <div className='modal__header'>
              <span className='lnr lnr-cross modal__close-btn' onClick={this.props.toggle} />
          </div>
        </ModalHeader>
        <ModalBody className="help-text-body">
        <div dangerouslySetInnerHTML={{ __html: this.props.body!==undefined && this.props.body!==null ? this.props.body
          .replace(/\\+n/g,'') : helptext.replace(/\\+n/g,'')}} />
        </ModalBody>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return {
      user: state.auth.user
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(HelpTextModal)));



// WEBPACK FOOTER //
// ./src/components/HelpTextModal.js